// 用户数
import React, { useEffect, useState } from "react";
import CountUp from "react-countup";
import { Statistic, Progress, Space } from "antd";

export default function LeftTopData(props) {
  const formatter = (value) => <CountUp end={value} separator="," />;
  const [enable, setEnable] = useState(0);
  const [disable, setDisable] = useState(0);
  const enableCount = 80;
  const disableCount = 20;
  useEffect(() => {
    rollFun(enableCount, "enable");
    rollFun(disableCount, "disable");
  }, []);

  const rollFun = (count, model) => {
    if (count > 0) {
      setInterval(() => {
        if (model === "enable") {
          enableFun(count);
        }
        if (model === "disable") {
          disableFun(count);
        }
      }, 60);
    } else {
      return 0;
    }
  };

  const enableFun = (count) => {
    setEnable((prevPercent) => {
      const newPercent = prevPercent + 5;
      if (newPercent > 100) {
        return 100;
      } else if (newPercent > count) {
        return count;
      }
      return newPercent;
    });
  };

  const disableFun = (count) => {
    setDisable((prevPercent) => {
      const newPercent = prevPercent + 5;
      if (newPercent > 100) {
        return 100;
      } else if (newPercent > count) {
        return count;
      }
      return newPercent;
    });
  };

  return (
    <>
      <div>
        <div className="users">
          <Statistic title="用户数" value={112893} formatter={formatter} />
        </div>
        <div className="user-info">
          <Space wrap>
            <div className="enable">
              <Progress
                className="user-progress"
                type="circle"
                percent={enable}
                trailColor="#ddd"
                strokeColor={{
                  "0%": "#108ee9",
                  "100%": "#87d068",
                }}
                format={(percent) => `${percent} %`}
              />
              <span className="progress-title">启用</span>
            </div>
            <div className="disable">
              <Progress
                className="user-progress"
                type="circle"
                percent={disable}
                trailColor="#ddd"
                format={(percent) => `${percent} %`}
                strokeColor={{
                  "0%": "#ff4d4f",
                  "100%": "#108ee9",
                }}
              />
              <span className="progress-title">禁用</span>
            </div>
          </Space>
        </div>
      </div>
    </>
  );
}
